import { Alert, AlertTitle, Grow } from "@mui/material";
import { types } from "api";

export const CreateAccountPageRegisteredUserAlert = (
	createdAccounts: types.RegisterUsersResponse,
): JSX.Element => {
	return (
		<Grow
			in={
				createdAccounts["already-present"] !== null &&
				createdAccounts["already-present"]?.length !== 0
			}
			timeout={1000}
		>
			<Alert severity="error">
				<AlertTitle>Error</AlertTitle>
				The following accounts could <strong> not be created.</strong>
				<ul>
					{createdAccounts["already-present"] &&
						createdAccounts["already-present"].map((item, index) => (
							<li key={index}>{item}</li>
						))}
				</ul>
			</Alert>
		</Grow>
	);
};
